<template>
    <div class="big-screen-body">
        <img :src="bigScreen" />
        <div class="text-area">
            <div class="big-screen-min-title">
                iOS & Android  Smart Phone
            </div>
            <div class="big-screen-title">
                画面を大画面テレビに!
            </div>
            <div class="big-screen-msg">
                アプリは大画面テレビにミラリンク機能が付き、<br/>
                スマホの画面をご自宅のテレビにミラーリング !<br/>
                簡単操作で、あなたのリビングがホームシアターに
            </div>
        </div>
    </div>
</template>
<script>
import bigScreen from '../../../images/big-screen.png'
export default {
    data () {
        return {
            bigScreen
        }
    }
}
</script>
<style scoped>
.big-screen-body {
    width: 100%;
    position: relative;
    box-sizing: border-box;
}
.big-screen-body img {
    display: block;
    width: 100%;
}
.text-area {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 60px;
    text-align: center;
}
.big-screen-min-title {
    font-size: 15px;
    font-family: ITC Avant Garde Gothic Std;
    font-weight: bold;
    color: #000000;
    line-height: 19.5px;
}
.big-screen-title {
    font-size: 26px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: bold;
    color: #000000;
    line-height: 37.5px;
    margin-top: 5px;
    margin-bottom: 5px;
}
.big-screen-msg {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
    line-height: 22px;
}
</style>